var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Opciones de Ayuda","storeName":"Help_options","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/helps","breadcrumbs":[
        {
          text: 'Información y soporte',
          disabled: false,
          href: '/admin/spot_helps'
        },
        {
          text: 'Opciones de ayuda',
          disabled: false,
          href: '#'
        }
      ]},scopedSlots:_vm._u([{key:"description",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed description-cell"},[_vm._v(" "+_vm._s(item.description)+" ")])]}},{key:"title",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed"},[_vm._v(" "+_vm._s(item.title)+" ")])]}},{key:"requires_photo",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed"},[_vm._v(" "+_vm._s(item.requires_photo ? 'Sí' : 'No')+" ")])]}},{key:"requires_description",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed"},[_vm._v(" "+_vm._s(item.requires_description ? 'Sí' : 'No')+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }